export const MessageTypes = {
  incoming: 'incoming',
  comment: 'comment',
  outgoing: 'outgoing',
  xaction: 'xaction',
  system: 'system',
  agent_typing: 'agent_typing',
  agent_untyping: 'agent_untyping'
}
